import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.3608 9.639C30.7683 10.0465 30.7683 10.7072 30.3608 11.1147L18.3087 23.1669C17.9012 23.5744 17.2405 23.5744 16.833 23.1669C16.4255 22.7594 16.4255 22.0987 16.833 21.6912L28.8851 9.639C29.2926 9.2315 29.9533 9.2315 30.3608 9.639Z",
			fill: "url(#paint0_linear_580_99184)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.3613 9.63903C30.6448 9.92248 30.7408 10.3432 30.6084 10.7216L22.9388 32.6346C22.7975 33.0384 22.424 33.3151 21.9965 33.3325C21.569 33.3499 21.1742 33.1047 21.0004 32.7137L16.7808 23.2196L7.28668 19C6.89571 18.8262 6.65042 18.4314 6.66786 18.0039C6.68531 17.5764 6.96194 17.2029 7.36576 17.0615L29.2788 9.39199C29.6571 9.25956 30.0779 9.35558 30.3613 9.63903ZM10.5394 18.1618L17.9951 21.4755C18.2312 21.5804 18.42 21.7692 18.5249 22.0052L21.8385 29.4609L27.9227 12.0777L10.5394 18.1618Z",
			fill: "url(#paint1_linear_580_99184)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_580_99184",
			x1: 23.5969,
			y1: 9.33337,
			x2: 23.5969,
			y2: 23.4725,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF699C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FE5763"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_580_99184",
			x1: 18.667,
			y1: 9.33337,
			x2: 18.667,
			y2: 33.3334,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF699C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FE5763"
			})]
		})] })
	]
});
export default SvgCardShare;
